// These are meant for growth team to be able to add product tours through
// intercom and for us developers to not delete them accidentally.

export const intercomIDs = {
  CURRENT_WORKSPACE_NAV_INVITE_MEMBERS: 'CURRENT_WORKSPACE_NAV_INVITE_MEMBERS',
  CURRENT_WORKSPACE_NAV_CREATE_NEW_BOARD: 'CURRENT_WORKSPACE_NAV_CREATE_NEW_BOARD',
  HEADER_ACTIONS_SHARE_BUTTON: 'HEADER_ACTIONS_SHARE_BUTTON',
  HEADER_ACTIONS_NEW_BUTTON: 'HEADER_ACTIONS_NEW_BUTTON',
  UPSELL_EXPLORE_UPGRADE_BUTTON: 'UPSELL_EXPLORE_UPGRADE_BUTTON',
  SWITCH_WORKSPACE: 'SWITCH_WORKSPACE',
};
